// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_pages_blog_blog_module_ts":"5981b9dddd5250e712c3","src_app_pages_shop_shop_module_ts":"89f956d59cc0bb16d177","src_app_pages_product_product_module_ts":"2007057d74ebf3d130e8"}[chunkId] + ".js";
};